import { surveys } from "config/algolia";

const DEFAULT_LENGTH = 10;
export const getSurveys = async ({
  filters = "",
  searchText = "",
  length = DEFAULT_LENGTH,
  offset = 0,
}) => {
  const result = await surveys.search(searchText, {
    filters,
    length,
    page: offset,
    hitsPerPage: length,
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>",
  });
  return {
    hits: result.hits,
    hitsLength: result.nbHits,
  };
};
